import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_GETTOUCH_REQUEST,
  fetchTouchFailure,
  fetchTouchSuccess,
  SEARCH_GETINTOUCH_REQUEST,
  searchGetInTouchSuccess,
  searchGetInTouchFailure
} from "./getInTouchAction";
import SDK from '../../config';

function* fetchGetInTouch(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/get/getInTouch/emails?page=${page}&limit=${limit}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(fetchTouchSuccess(data.data));
  } catch (error) {
    console.error("Error fetching data:", error);
    yield put(fetchTouchFailure(error.toString()));
  }
}

// Search get in touch data saga
function* searchGetInTouchData(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/search/getInTouch/emails?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(searchGetInTouchSuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(searchGetInTouchFailure(error.toString()));
  }
}

function* getInTouchSaga() {
  yield takeLatest(FETCH_GETTOUCH_REQUEST, fetchGetInTouch);
  yield takeLatest(SEARCH_GETINTOUCH_REQUEST, searchGetInTouchData);
}

export default getInTouchSaga;
